import { useState } from "react"
import { studentRequest } from "services/requests"

const prefix = "licenses"
const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)

  const getInvoice = async ({ folio = "" }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/invoice/${folio}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || null
  }

  const getLicenseStatus = async ({ groupId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/status/${groupId}`,
      body: null,
      method: "get",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || null
  }

  const addOrder = async ({ groupId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/addOrder/${groupId}`,
      body: null,
      method: "post",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data || null
  }

  return {
    isFetching,
    getInvoice,
    getLicenseStatus,
    addOrder,
  }
}

export default useApi
